
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper'

import 'swiper/scss'
import 'swiper/scss/autoplay'

import styles from './logo_carousel.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'

function LogoCarousel(props) {
	const fields = props.fields

	const sliderConfig = {
		modules: [Autoplay],
		autoplay: {delay: 5000},
		spaceBetween: 30,
		slidesPerView: 5,
		loop: true,
		breakpoints: {
			0: {
				slidesPerView: 3,
				spaceBetween: 40
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 50
			},
			1240: {
				slidesPerView: 5,
				spaceBetween: 75
			},
		}
	}

	return <BlockWrapper {...props} className={styles.logo_carousel}>
		<ScrollAnimation styles={styles}>
			<Swiper className={styles.logos} {...sliderConfig}>
				{fields.logos.map((logo, index) => {
					return <SwiperSlide className={styles.logo_slide} key={index}>
						{logo.logo && <Image className={styles.logo_color} {...logo.logo} />}
						{logo.logo_secondary && <Image className={styles.logo_grey} {...logo.logo_secondary} />}
					</SwiperSlide>
				})}
			</Swiper>
		</ScrollAnimation>
	</BlockWrapper>
}

export default LogoCarousel